module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [(_vm.screenSize.mobile === false) ? _c('div', {
    staticClass: "base-five large-text high-light border-bottom"
  }, [_vm._m(0), _vm._v(" "), (_vm.loaded.quotes && _vm.screenSize.mobile === false) ? _c('dsMarquee', {
    attrs: {
      "language": _vm.language,
      "quotes": _vm.quotes
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.screenSize.mobile === false) ? _c('div', {
    staticClass: "base-five border-bottom main-column"
  }, [_c('dsMenu', {
    attrs: {
      "language": _vm.language
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.screenSize.mobile === false) ? _c('div', {
    staticClass: "base-five border-bottom secondary-column"
  }, [_c('div', {
    staticClass: "search-field"
  }, [(_vm.language === "nl") ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTerm),
      expression: "searchTerm"
    }],
    staticClass: "large-text secondary-color center-vertical",
    attrs: {
      "placeholder": "Zoek..."
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.language === "en") ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTerm),
      expression: "searchTerm"
    }],
    staticClass: "large-text secondary-color center-vertical",
    attrs: {
      "placeholder": "Search..."
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    on: {
      "click": _vm.search
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "language-switch"
  }, [_c('router-link', {
    staticClass: "language-switch-button",
    class: {
      active: (_vm.language === "en")
    },
    attrs: {
      "to": {
        name: _vm.routeName,
        params: {
          language: 'en',
          slug: _vm.routeSlug
        }
      }
    }
  }, [_vm._v("EN")]), _vm._v(" "), _c('router-link', {
    staticClass: "language-switch-button",
    class: {
      active: (_vm.language === "nl")
    },
    attrs: {
      "to": {
        name: _vm.routeName,
        params: {
          language: 'nl',
          slug: _vm.routeSlug
        }
      }
    }
  }, [_vm._v("NL")])], 1)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "quote-marks",
    attrs: {
      "id": "quote-marks"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/quotes333.svg")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-379ef0e6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dsHeader.vue
// module id = 216
// module chunks = 2